import { render } from "./Testing.vue?vue&type=template&id=cc24182e"
import script from "./Testing.vue?vue&type=script&lang=js"
export * from "./Testing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__